// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1lfDP","footer":"ModalCreateQualiphyProcedure_footer__16-8-","additionData":"ModalCreateQualiphyProcedure_additionData__2f5Qt"};